export default {
    base: {
        state: 'declaration.incomeTax.financialReport',
        config: {
            url: '/financialReport',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'declaration.incomeTax.financialReport.list',
            title: '财务报表导入',
        },
    },
    list: {
        state: 'declaration.incomeTax.financialReport.list',
        config: {
            url: '/list',
            template: require('./view/financialReport.html'),
            controller: 'financialReportCtrl',

        },
    },
}



// WEBPACK FOOTER //
// ./src/app/declaration/incomeTax/financialReport/routers.js